import { post, get, postJson  } from '../api/axios'

 const common = {
   async decrypt( p = '',url='openController/taohd/security',type = 'post') {
    //  console.log(type);
     if (type == 'get') {
     return  await get(url, p)
    } else {
      return await postJson(url, p)
    }
   },
}

export default common